import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	linkedAlertsSubTitleHeading: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.linked-alerts-field.linked-alerts-sub-title-heading',
		defaultMessage: 'Linked alerts',
		description:
			'The subtitle heading for the Linked Alerts section of the new incident management settings info card.',
	},
	linkedAlertsSubTitleBody: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.linked-alerts-field.linked-alerts-sub-title-body',
		defaultMessage:
			'View and link monitoring alerts to an incident, and see the status of linked alerts.',
		description:
			'The body text for the Linked Alerts section of the incident management settings info card.',
	},
	linkedAlertsLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.linked-alerts-field.linked-alerts-learn-more-link',
		defaultMessage: 'Learn more about linking alerts to an incident.',
		description:
			'The learn more text for Linked Alerts section of the incident management settings info card.',
	},
});
